/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteRegisterDevicePlacementRequest } from '../../models/delete-register-device-placement-request';
import { RegisteredDeviceResponse } from '../../models/registered-device-response';

export interface DeleteDevicePlacement$Params {
      body: DeleteRegisterDevicePlacementRequest
}

export function deleteDevicePlacement(http: HttpClient, rootUrl: string, params: DeleteDevicePlacement$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDeviceResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteDevicePlacement.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegisteredDeviceResponse>;
    })
  );
}

deleteDevicePlacement.PATH = '/api/regdevice/placement';
